import React, { useEffect } from "react";
import { connect } from "react-redux";
import { RootState } from "../../../../redux/rootReducers";

import GstrOneAccordian from "./GstrOneAccordian/GstrOneAccordian";
import "../styles/gstr.scss";
import "../../Styles/index.scss";

import GstOneTotal from "./GstOneTotal";
import {
  headers,
  singleHeaders,
} from "../../../../constant/tableHeadersConstants/gst";
import { GstrOneDataType } from "../../../../commonTypes/gstTypes";

type AppProps = {
  fetching: boolean;
  handleGstrOneInvoiceList: (id: string, data: any) => void;
  gstrOneInvoiceData: any;
  invoiceSourceKey: string;
  nestedSourceKey: string;
  gstr1Data: GstrOneDataType | {};
  setGstr1Data: (data: any) => void;
  gstrOneData: GstrOneDataType | {};
  showhsnCount: boolean;
  setShowhsnCount: any;
};

const GstrOneTable = ({
  fetching,
  invoiceSourceKey,
  gstrOneInvoiceData,
  nestedSourceKey,
  gstr1Data,
  gstrOneData,
  setGstr1Data,
  handleGstrOneInvoiceList,
  showhsnCount,
  setShowhsnCount,
}: AppProps) => {
  useEffect(() => {
    let finalData = JSON.parse(JSON.stringify(gstr1Data));
    if (finalData?.length) {
      finalData?.map((item: any) => {
        let newGstrId: string = "";
        let singleData: any = [];
        if (
          item?.id == "4aTaxable" ||
          item?.id == "4bTaxable" ||
          item?.id == "5ATaxable" ||
          item?.id == "5BTaxable" ||
          item?.id == "12HSN" ||
          item?.id == "13Documents"
        ) {
          if (item.id == invoiceSourceKey) {
            newGstrId = changeGstrId(invoiceSourceKey);
            singleData = gstrOneInvoiceData[newGstrId];
            if (singleData?.length) {
              item.data = { ...item.data, srcData: [...singleData] };
            }
          }
        } else if (item?.id == "7Taxable") {
          if (item.id == invoiceSourceKey) {
            let creditNote = gstrOneInvoiceData["gstr17_credit_note"];
            let debitNote = gstrOneInvoiceData["gstr17_debit_note"];
            let taxInvoice = gstrOneInvoiceData["gstr17_tax_invoice"];
            if (creditNote?.length || debitNote?.length || taxInvoice?.length) {
              item.data = {
                ...item.data,
                srcData: [...creditNote, ...debitNote, ...taxInvoice],
              };
            }
          }
        } else if (
          item.id == invoiceSourceKey &&
          item?.id == "9BCredit/Debit"
        ) {
          let singleItemData = structuredClone(item?.data);
          let finalObj: any = {};
          for (let key in singleItemData) {
            let finalData = singleItemData[key]?.map((singleItem: any) => {
              if (singleItem?.id == nestedSourceKey) {
                singleData = gstrOneInvoiceData[nestedSourceKey];
                if (!!singleData?.length) {
                  return { ...singleItem, srcData: [...singleData] };
                } else {
                  return { ...singleItem };
                }
              } else {
                return { ...singleItem };
              }
            });
            finalObj[key] = finalData;
          }
          if (item) {
            item.data = finalObj;
          }
        } else {
          let singleItemData = structuredClone(item?.data);

          let newSingleInvoiceData =
            Array.isArray(singleItemData) &&
            singleItemData?.length > 0 &&
            singleItemData?.map((singleItem: any) => {
              if (singleItem?.id == nestedSourceKey) {
                singleData = gstrOneInvoiceData[nestedSourceKey];
                if (singleData?.length) {
                  return { ...singleItem, srcData: [...singleData] };
                } else {
                  return { ...singleItem };
                }
              } else {
                return { ...singleItem };
              }
            });

          if (
            Array.isArray(newSingleInvoiceData) &&
            newSingleInvoiceData?.length
          ) {
            item.data = [...newSingleInvoiceData];
          }
        }
      });

      setGstr1Data([...finalData]);
    }
  }, [gstrOneInvoiceData]);

  function changeGstrId(id: string) {
    switch (id) {
      case "4aTaxable":
        return "gstr14A";
      case "4bTaxable":
        return "gstr14B";
      case "5ATaxable":
        return "gstr15A";
      case "5BTaxable":
        return "gstr15B";
      case "6AExports":
        return "gstr16A";
      case "6BSupplies":
        return "gstr16B";
      case "7Taxable":
        return "gstr17";
      case "8Nil":
        return "gstr18";
      case "9BCredit/Debit":
        return "gstr19B";
      case "12HSN":
        return "gstr112";
      case "13Documents":
        return "gstr113";

      default:
        return "";
    }
  }

  const handleExpandCollapse = (type: string) => {
    let iterableData = JSON.parse(JSON.stringify(gstr1Data));

    iterableData?.map((item: any) => {
      if (type === "expand") {
        item.isOpen = true;
      }
      if (type === "collapse") {
        item.isOpen = false;
      }
    });

    setGstr1Data([...iterableData]);
  };

  return (
    <>
      <div
        className="col-md-12 mt-4 mb-2"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <div>
            <div className="view_gstr_form">View GSTR-1 Form Below</div>
            <div className="below-header">Amount in ₹ for all tables</div>
          </div>

          {/* commented for future use  */}
          {/* <div>
                <ButtonDropdown
                            isOpen={toggle}
                            toggle={() => {
                                setToggle(!toggle)
                            }}
                        >
                            <DropdownToggle
                                caret
                                color="secondary"
                                style={{ backgroundColor: "white", color: "red", border: "1px solid red" }}
                                outline
                            >
                                 <span className='mr-2'>
                                    <img src={CalculateFillIcon} alt="Download" />
                                </span> 

                                Total Only
                            </DropdownToggle>

                            <DropdownMenu style={{ width: "100%", minWidth: "7px" }}>
                           
                            </DropdownMenu>
                        </ButtonDropdown>
                </div>

                <div>
                <ButtonDropdown
                            isOpen={toggle}
                            toggle={() => {
                                setToggle(!toggle)
                            }}
                        >
                            <DropdownToggle
                                caret
                                color="secondary"
                                style={{ backgroundColor: "white", color: "red", border: "1px solid red" }}
                                outline
                            >
                                 <span className='mr-2'>
                                    <img src={AnchorFillIcon} alt="Download" />
                                </span> 

                                Navigator 
                            </DropdownToggle>

                            <DropdownMenu style={{ width: "100%", minWidth: "7px" }}>
                           
                            </DropdownMenu>
                        </ButtonDropdown>
                </div> */}
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <div
            className="collapse-open"
            style={{ cursor: "pointer", color: "red" }}
            onClick={() => handleExpandCollapse("expand")}
          >
            Expand All
          </div>
          <div
            className="collapse-open"
            style={{ cursor: "pointer", color: "red" }}
            onClick={() => handleExpandCollapse("collapse")}
          >
            Collapse All
          </div>
        </div>
      </div>

      <GstrOneAccordian
        data={gstr1Data}
        headers={headers}
        singleHeader={singleHeaders}
        handleGstrOneInvoiceList={handleGstrOneInvoiceList}
        settingData={setGstr1Data}
        type="gstrone"
        showhsnCount={showhsnCount}
        setShowhsnCount={setShowhsnCount}
      />

      <GstOneTotal data={gstrOneData} />

      <div className="gstr-line col-md-12"></div>
      {/* commented for future use */}
      {/* <div className="col-md-12 d-flex justify-content-end align-items-center mt-5" style={{gap:"10px"}}>

            <button className="btn btn-outline-secondary">Exit</button>
            <button className="btn btn-outline">Save Only</button>
            <button className="btn btn-primary">Save & Lock</button>
        </div> */}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.gst.fetching,
});

export default connect(mapStateToProps)(GstrOneTable);
